import { z } from 'zod';

export const customerSubscription = z.object({
  subscriber: z.boolean().nullable(),
  subscriptionDate: z.string().nullable(),
  nextRenewDate: z.string().nullable(),
  subscriptionStatus: z
    .object({
      name: z.string(),
    })
    .nullable(),
  subscriptionPlan: z
    .object({
      name: z.string(),
      price: z.number(),
      title: z.union([z.string(), z.undefined()]),
    })
    .nullable(),
  subscriptionSegment: z
    .object({
      name: z.string(),
    })
    .nullable(),
});

export const subscription = z.string();
export const subscriptions = z.array(subscription);

export type CustomerSubscription = z.infer<typeof customerSubscription>;
export type Subscription = z.infer<typeof subscription>;
export type Subscriptions = z.infer<typeof subscriptions>;

export const subscriptionOption = z.object({
  name: z.string(),
  price: z.number(),
  imgSrc: z.string(),
  title: z.string(),
  priceId: z.string(),
  trialPeriodDays: z.number().nullable(),
});

export type SubscriptionOption = z.infer<typeof subscriptionOption>;

export const subscriptionsOptions = z.array(subscriptionOption);

export type SubscriptionsOptions = z.infer<typeof subscriptionsOptions>;

export const openCustomerPortalResponse = z.string();

export type OpenCustomerPortalResponse = z.infer<typeof openCustomerPortalResponse>;
